import { render, staticRenderFns } from "./GlassesLensShow.vue?vue&type=template&id=82a106a4&"
import script from "./GlassesLensShow.vue?vue&type=script&lang=js&"
export * from "./GlassesLensShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports